import cx from 'clsx';

export type TabItem<T> = {
  id: T;
  content: React.ReactNode;
};

export type SegmentControlTabProps<T> = {
  items: TabItem<T>[];
  selectedTab: T;
  className?: string;
  onChange: (id: T) => void;
};

export default function SegmentControlTab<T>({
  selectedTab,
  items,
  className,
  onChange,
}: SegmentControlTabProps<T>) {
  return (
    <div
      className={cx('w-full p-[2px] rounded-3xl bg-secondary-air', className)}
    >
      <div className="relative flex w-full items-center typo-title100-regular">
        {items.map((item) => {
          return (
            <button
              key={item.id as string}
              type="button"
              onClick={() => onChange(item.id)}
              className={cx(
                'flex justify-center items-center flex-grow h-40 py-[9px]',
                selectedTab === item.id
                  ? 'typo-title100-semibold text-gray-000 bg-gray-1200 rounded-[20px]'
                  : 'typo-title100-regular text-gray-800',
              )}
            >
              {item.content}
            </button>
          );
        })}
      </div>
    </div>
  );
}
